module.exports = __webpack_public_path__ + "static/media/addon-challenges.d9417ad6.png";